import { Button } from "primereact/button";
import { useEffect, useRef, useState } from "react";
import {
  Enum_ValidationString,
  capitalizeFormat,
  checkNumCharactersNameAndSurname,
  checkValidationRequiredString,
  clearStringData,
  getIsOnline,
  goTo,
} from "../../utilities/common.utilities";
import { InputText } from "primereact/inputtext";
import { Password } from "primereact/password";
import {
  RegisterUser,
  registerUser,
} from "../../service/registerAccount.service";
import "./SignupStyle.css";
import pharmaModel, { Store } from "../../static/pharma.model";
import { getPharmaList } from "../../service/pharmaList.service";
import { Dialog } from "primereact/dialog";
import MapTabComponent, { MapProps } from "../Pharmacy/map-tab/mapTab.component";
import SignupInfoPharmacy from "./SignupInfoPharmacy/signupInfoPharmacy";
import { getUser } from "../../service/login.service";
import GoogleMapReact from "google-map-react";
import { fromAddress } from "react-geocode";
import { googleMapsApiKey } from "../../static/google-map-key";
import { Toast } from "primereact/toast";
import { ConfirmDialog, confirmDialog } from "primereact/confirmdialog";
import { CalculateGeoDistance, GetNearlyLocation } from "../../utilities/geo.utilities";
import { APP_ID_PLATFORM, MAXLENGTH_EMAIL, MAXLENGTH_NAME, MAXLENGTH_NATIONAL_ID_NUMBER, MAXLENGTH_PASSWORD, MAXLENGTH_PHONE, MAXLENGTH_SURNAME, MAXLENGTH_USERNAME } from "../../static/constants";
import { Toolbar } from "primereact/toolbar";
import ShareComponent from "../Share/share.component";
import { SpecialZoomLevel, ViewMode, Viewer } from "@react-pdf-viewer/core";
import LoadingSpinner from "../loading-spinner/loading-spinner";
import { Worker } from '@react-pdf-viewer/core';
import AutocompletePharmacy, { Enum_TypeSuggestion, autocompletePharmacyOutputModel } from "../AutocompletePharmacy/autocompletePharmacy";
import {installPWA, onClickInstallButton, pwaInstalled} from "../../utilityPWA";
import PopupInstallComponent from "../PopupInstall/popupInstall.component";
import PopupGeolocationComponent from "../PopupGeolocation/popupGeolocation.component";
import FooterPreLoginComponent from "../Footer/footer-pre-login.component";
import { useConnectivity } from "../../context/connectivityContext";

export type Pharmacy_ItemList = {
  groupId: number;
  groupName: string;
  store: Store;
  distanceFromPosition?: number;
};

type InputInfoStatus = {
  value: string;
  valid: boolean;
  showError: boolean;
};

type text = {
  lat:any, 
  lng:any, 
  text:any
}

type customButtonProps = {
  position: number
}

export default function SignupComponent() {

  const defaultInfoStatus: InputInfoStatus = {
    value: "",
    valid: false,
    showError: false,
  };

  let navigationCoords: MapProps = { lat: 0, lng: 0 };
  let listaFarmacieTemp: Pharmacy_ItemList[] = [];

  const [name, setName] = useState<InputInfoStatus>(defaultInfoStatus);
  const [surname, setSurname] = useState<InputInfoStatus>(defaultInfoStatus);
  const [checkCharsNameSurname, setCheckCharsNameSurname] = useState<boolean>(true);

  const [nationalIdNumber, setNationalIdNumber] = useState<InputInfoStatus>(defaultInfoStatus);
  const [phone, setPhone] = useState<InputInfoStatus>(defaultInfoStatus);

  const [email, setEmail] = useState<InputInfoStatus>(defaultInfoStatus);
  const [matchEmail, setMatchEmail] = useState<InputInfoStatus>(defaultInfoStatus);
  const [username, setUsername] = useState<InputInfoStatus>(defaultInfoStatus);

  const [password, setPassword] = useState<InputInfoStatus>(defaultInfoStatus);
  const [matchPassword, setMatchPassword] = useState<InputInfoStatus>(defaultInfoStatus);
  const [showErrorPharmacy, setShowErrorPharmacy] = useState<boolean>(false);

  const [centerMap, setCenterMap] = useState<MapProps>({ lat: 0, lng: 0 });

  const [isGettingCoordinates, setStateGettingCoordinated] = useState<boolean>(false);
  const [userCoordinates, setUserCoordinates] = useState<MapProps>({ lat: 0, lng: 0 });
 
  const [showAlertGeoLocalization, setShowAlertGeoLocalization] = useState<boolean>(false);
  const [zoom, setZoom] = useState<number>(17);
  const [address, setAddress] = useState<string>('')

  const toast = useRef<Toast>(null);
  const [mapRef, setMapRef] = useState<any>(null);
  const [geoLocationActive, setGeoLocationActive] = useState<boolean>(false);

  const [showSharingComponent, setShowSharingComponent] = useState<boolean>(false);
  const [showTermsOfUse, setShowTermsOfUse] = useState<boolean>(false);

  const [popupSuccessVisible, setPopupSuccessVisible] = useState(false);
  const [showPopupInstall, setShowPopupInstall] = useState<boolean>(false);
  const { isOnline } = useConnectivity();
  const [loadingPharmacy, setLoadingPharmacy] = useState<boolean>(true);

  const footerContent = (
    <div>
      <Button
        label="Ok"
        icon="pi pi-check"
        onClick={() => {
          setPopupSuccessVisible(false);
          getUser(username.value, password.value);
        }}
        autoFocus
      />
    </div>
  );

   // Consente di centrare la posizione, modificando lo zoom in maniera da poter vedere almeno una farmacia
   const centerOnMyPosition = (lat: number, lng: number) => {
    let newCenterMap: MapProps = {lat: lat, lng: lng};

    setUserCoordinates(newCenterMap);  // disegna il pallino tondo con l' animazione

    // Prendo le coordinate di tutte le farmacie
    let coordinates: MapProps[] = listaFarmacie?.map(f => ({ lat: f.store.latitude, lng: f.store.longitude } as MapProps));

    // Recupero le coordinate delle farmacie più vicine
    let coordNearly: MapProps | null= GetNearlyLocation(newCenterMap, coordinates);

    if(coordNearly) {

      let bounds = new mapRef.maps.LatLngBounds();
      bounds.extend(newCenterMap)
      bounds.extend({lat: coordNearly.lat, lng: coordNearly.lng} as MapProps)

      mapRef.map.fitBounds(bounds);

      // Se la centratura è rimasta invariata, imposto il centro e lo zoom dall' oggetto che rappresenta
      // la mappa 
      if(centerMap.lat === newCenterMap.lat && centerMap.lng === newCenterMap.lng) {
        mapRef.map.setCenter({lat: lat, lng: lng})
        mapRef.map.setZoom(mapRef.map.getZoom() - 1)
      } 
      // Altrimenti se la centratura è diversa, posso impostare i nuovi valori direttamente con le variabili legate
      // agli state
      else {
        setCenterMap(newCenterMap);
        setZoom(mapRef.map.getZoom() - 1);
      }
    }

  }

  function setPosition(position: GeolocationPosition,zoom?: number) {

    if (position.coords.latitude && position.coords.longitude) {

      let positionUser: MapProps = {
        lat: position.coords.latitude,
        lng: position.coords.longitude
      }

      navigationCoords = {
        lat: position.coords.latitude,
        lng: position.coords.longitude
      }


      setUserCoordinates(positionUser)
      setCenterMap(positionUser)
      setGeoLocationActive(true)


      if(!isCalculateDistances() && listaFarmacieTemp?.length > 0) {

        let newList: Pharmacy_ItemList[] = listaFarmacieTemp.map((f: Pharmacy_ItemList) => {
          let pharmacy: Pharmacy_ItemList = {
            groupId: f.groupId,
            groupName: f.groupName,
            store: f.store,
            distanceFromPosition: CalculateGeoDistance(position.coords.latitude,position.coords.longitude,f.store.latitude,f.store.longitude)
          }

          return pharmacy;
        })

        setListaFarmacie(newList);
      }

    } 
    else {
      impostaCoordinateAssenzaValori();
    }

    setStateGettingCoordinated(true);

    if(zoom) {
      setZoom(zoom)
    }
  }

  function impostaCoordinateAssenzaValori(): void {
    setCenterMap( { lat: 41.89671, lng: 12.48220 } )
  }

  const [listaFarmacie, setListaFarmacie] = useState<Pharmacy_ItemList[]>([]);
  const [showForm, setShowForm] = useState<boolean>(false);
  const [pharmaSelected, setPharmaSelected] = useState<Pharmacy_ItemList>();
  const [filteredPharma, setFilteredPharma] = useState<Pharmacy_ItemList[]>([]);

  function onChangeName(nameValue: string): void {
    nameValue = nameValue ? capitalizeFormat(nameValue) : '';

    nameValue = clearStringData(nameValue, false);
    let nameInfo: InputInfoStatus = {
      value: nameValue,
      valid: checkValidationRequiredString(
        nameValue,
        Enum_ValidationString.Any
      ),
      showError: name.showError,
    };

    let validTotCharsNameSurname: boolean = checkNumCharactersNameAndSurname(nameValue,surname.value);
    setCheckCharsNameSurname(validTotCharsNameSurname);
    setName(nameInfo);
  }

  function onBlurName() {

    let nameValue = clearStringData(name.value, true);

    let blurNameInfo: InputInfoStatus = {
      value: nameValue,
      valid: checkValidationRequiredString(
        nameValue,
        Enum_ValidationString.Any
      ),
      showError: name.showError,
    };
    blurNameInfo.showError = true;

    setName(blurNameInfo);
  }

  function onChangeSurname(surnameValue: string): void {
    surnameValue = surnameValue ? capitalizeFormat(surnameValue) : '';
    surnameValue = clearStringData(surnameValue, false);
    let surnameInfo: InputInfoStatus = {
      value: surnameValue,
      valid: checkValidationRequiredString(
        surnameValue,
        Enum_ValidationString.Any
      ),
      showError: surname.showError,
    };

    let validTotCharsNameSurname: boolean = checkNumCharactersNameAndSurname(name.value,surnameValue);
    setCheckCharsNameSurname(validTotCharsNameSurname);
    setSurname(surnameInfo);
  }
  function onBlurSurname() {

    let surnameValue: string = clearStringData(surname.value, true);

    let blurSurnameInfo: InputInfoStatus = {
      value: surnameValue,
      valid: checkValidationRequiredString(
        surnameValue,
        Enum_ValidationString.Any
      ),
      showError: surname.showError,
    };
    blurSurnameInfo.showError = true;
    setSurname(blurSurnameInfo);
  }

  function onChangeUsername(usernameValue: string) {
    // per l' username rimuovo tutti gli spazi
    usernameValue = usernameValue ? usernameValue.replaceAll(' ','') : ''; 

    let usernameInfo: InputInfoStatus = {
      value: usernameValue,
      valid: checkValidationRequiredString(
        usernameValue,
        Enum_ValidationString.Username
      ),
      showError: username.showError,
    };
    setUsername(usernameInfo);
  }
  function onBlurUsername() {
    let blurUsernameInfo: InputInfoStatus = {
      value: username.value,
      valid: checkValidationRequiredString(
        username.value,
        Enum_ValidationString.Username
      ),
      showError: username.showError,
    };
    blurUsernameInfo.showError = true;
    setUsername(blurUsernameInfo);
  }

  function onChangePassword(passwordValue: string) {
    // per la password rimuovo tutti gli spazi
    passwordValue = passwordValue ? passwordValue.replaceAll(' ','') : '';
    let checkMatchPsw: boolean = checkValidationRequiredString( matchPassword.value, Enum_ValidationString.Password, passwordValue )
    let passwordInfo: InputInfoStatus = {
      value: passwordValue,
      valid: checkValidationRequiredString(
        passwordValue,
        Enum_ValidationString.Password
      ),
      showError: password.showError,
    };
    setPassword(passwordInfo);
    setMatchPassword({ 
      value: matchPassword.value,
      valid: checkMatchPsw,
      showError: matchPassword.showError
    })

  }
  function onBlurPassword() {
    let blurPasswordInfo: InputInfoStatus = {
      value: password.value,
      valid: checkValidationRequiredString(
        password.value,
        Enum_ValidationString.Password
      ),
      showError: password.showError,
    };
    blurPasswordInfo.showError = true;
    setPassword(blurPasswordInfo);
  }

  function onChangePhone(telefono: string | null) {
    let phoneInput: string = telefono ? telefono.toString() : "";
    // per il telefono rimuovo tutti gli spazi
    phoneInput = phoneInput.replaceAll(' ','');

    let phoneInfo: InputInfoStatus = {
      value: phoneInput,
      valid: checkValidationRequiredString(
        phoneInput,
        Enum_ValidationString.NumberCode
      ),
      showError: phone.showError,
    };

    setPhone(phoneInfo);
  }
  function onBlurPhone() {
    let blurPhoneInfo: InputInfoStatus = {
      value: phone.value,
      valid: checkValidationRequiredString(
        phone.value,
        Enum_ValidationString.NumberCode
      ),
      showError: phone.showError,
    };
    blurPhoneInfo.showError = true;
    setPhone(blurPhoneInfo);
  }

  function onChangeNationalIdNumber(NationalIdNumberValue: string) {

    NationalIdNumberValue = NationalIdNumberValue ? NationalIdNumberValue.toUpperCase() : '';
    // per il codice fiscale rimuovo tutti gli spazi
    NationalIdNumberValue = NationalIdNumberValue.replaceAll(' ','');

    let NationalIdNumberInfo: InputInfoStatus = {
      value: NationalIdNumberValue,
      valid: checkValidationRequiredString(
        NationalIdNumberValue,
        Enum_ValidationString.NationalIdNumber
      ),
      showError: nationalIdNumber.showError,
    };
    setNationalIdNumber(NationalIdNumberInfo);
  }
  function onBlurNationalIdNumber() {
    let blurNationalIdNumberInfo: InputInfoStatus = {
      value: nationalIdNumber.value,
      valid: checkValidationRequiredString(
        nationalIdNumber.value,
        Enum_ValidationString.NationalIdNumber
      ),
      showError: nationalIdNumber.showError,
    };
    blurNationalIdNumberInfo.showError = true;
    setNationalIdNumber(blurNationalIdNumberInfo);
  }

  function getErrorCodiceFiscale(): string {
    let messageError: string = "";
    if (!nationalIdNumber.valid) {
      if (nationalIdNumber.value.length === 0) {
        messageError = "Campo obbligatorio";
      } else {
        messageError = "Codice fiscale non valido";
      }
    }

    return messageError;
  }

  function onChangeEmail(emailValue: string) {
    emailValue = emailValue ? emailValue.toLowerCase() : '';
    // per l' email rimuovo tutti gli spazi
    emailValue = emailValue.replaceAll(' ','');

    let checkMatchEmail: boolean = checkValidationRequiredString( matchEmail.value, Enum_ValidationString.Email, emailValue )
    let EmailInfo: InputInfoStatus = {
      value: emailValue,
      valid: checkValidationRequiredString(
        emailValue,
        Enum_ValidationString.Email
      ),
      showError: email.showError,
    };
    setEmail(EmailInfo);
    setMatchEmail({ 
      value: matchEmail.value,
      valid: checkMatchEmail,
      showError: matchEmail.showError
    })
  }
  function onBlurEmail() {
    let blurEmail: InputInfoStatus = {
      value: email.value,
      valid: checkValidationRequiredString(
        email.value,
        Enum_ValidationString.Email
      ),
      showError: email.showError,
    };
    blurEmail.showError = true;
    setEmail(blurEmail);
  }

  function getErrorEmail(): string {
    let messageError: string = "";
    if (!email.valid) {
      if (email.value.length === 0) {
        messageError = "Campo obbligatorio";
      } else {
        messageError = "Indirizzo email non valido";
      }
    }

    return messageError;
  }

  function onChangeMatchEmail(valueEmail: string) {
    valueEmail = valueEmail ? valueEmail.toLowerCase() : '';
    // per l' email rimuovo tutti gli spazi
    valueEmail = valueEmail.replaceAll(' ','');

    let matchEmailInfo: InputInfoStatus = {
      value: valueEmail,
      valid: checkValidationRequiredString(
        valueEmail,
        Enum_ValidationString.Email
      ),
      showError: matchEmail.showError,
    };
    setMatchEmail(matchEmailInfo);

  }
  function onBlurMatchEmail() {
    let blurMatchEmail: InputInfoStatus = {
      value: matchEmail.value,
      valid: checkValidationRequiredString(
        matchEmail.value,
        Enum_ValidationString.Email,
        email.value
      ),
      showError: matchEmail.showError,
    };
    blurMatchEmail.showError = true;
    setMatchEmail(blurMatchEmail);
  }

  function onChangeMatchPassword(valuePassword: string) {
    // per la password rimuovo tutti gli spazi
    valuePassword = valuePassword ? valuePassword.replaceAll(' ','') : '';

    let matchPasswordInfo: InputInfoStatus = {
      value: valuePassword,
      valid: checkValidationRequiredString(
        valuePassword,
        Enum_ValidationString.Password,
        password.value
      ),
      showError: matchPassword.showError,
    };
    setMatchPassword(matchPasswordInfo);

  }
  function onBlurMatchPassword() {
    let blurMatchPassword: InputInfoStatus = {
      value: matchPassword.value,
      valid: checkValidationRequiredString(
        matchPassword.value,
        Enum_ValidationString.Password,
        password.value
      ),
      showError: matchPassword.showError,
    };
    blurMatchPassword.showError = true;
    setMatchPassword(blurMatchPassword);
  }

  function getErrorMatchEmail(): string {
    let messageErrorEmail: string = "";

    if (matchEmail !== email) {
      messageErrorEmail = "L'email non corrisponde";
    } else {
      messageErrorEmail = "Campo obbligatorio";
    }
    return messageErrorEmail;
  }

  function getErrorMatchPassword(): string {
    let messageErrorPassword: string = "";

    if (matchPassword !== password) {
      messageErrorPassword = " La password non corrisponde ";
    } else {
      messageErrorPassword = " Campo obbligatorio ";
    }
    return messageErrorPassword;
  }

  // Controlla la validità dei campi
  function isFormValid(): boolean {
    return (
      name.valid &&
      surname.valid &&
      nationalIdNumber.valid &&
      email.valid &&
      phone.valid &&
      matchEmail.valid &&
      username.valid &&
      password.valid &&
      matchPassword.valid &&
      checkCharsNameSurname
    );
  }

  // Funzione richiamata al click del pulsante "Registrati"
  function onSignup(): void {
    if (isFormValid()) {
      let request: RegisterUser = {
        FirstName: name.value,
        LastName: surname.value,
        SignInName: username.value,
        Email: email.value,
        Password: password.value,
        MobilePhone: phone.value,
        NationalIdNumber: nationalIdNumber.value,
        StoreCode: pharmaSelected?.store.storeCode,
        GroupId: pharmaSelected?.groupId.toString(),
        OverrideIdCreatorPlatformType: APP_ID_PLATFORM, // parametro fisso
      };
      registerUser(request).then((x) => {
        if (x === "OK") {
          setPopupSuccessVisible(true);
        } else {
          setPopupSuccessVisible(false);
        }
      });
    } else {
      onSignupShowError();
    }
  }

  // Funzione richiamata quando al click del pulsante "Registrati" sono presenti degli errori
  // e serve per far visualizzare gli errori impostando gli showError a true
  function onSignupShowError(): void {
    setName(() => ({ value: name.value, showError: true, valid: name.valid }));
    setSurname(() => ({ value: surname.value, showError: true, valid: surname.valid }));
    setNationalIdNumber(() => ({ value: nationalIdNumber.value, showError: true, valid: nationalIdNumber.valid }));
    setPhone(() => ({ value: phone.value, showError: true, valid: phone.valid }));
    setEmail(() => ({ value: email.value, showError: true, valid: email.valid }));
    setMatchEmail(() => ({ value: matchEmail.value, showError: true, valid: matchEmail.valid }));
    setUsername(() => ({ value: username.value, showError: true, valid: username.valid }));
    setPassword(() => ({ value: password.value, showError: true, valid: password.valid }));
    setMatchPassword(() => ({ value: matchPassword.value, showError: true, valid: matchPassword.valid })); 
  }

      // Definisci i limiti dell'Italia
      const italyBounds = {
        north: 48.092,
        south: 34.4897,
        west: 6.6273,
        east: 18.7849
      };
    
      const handleApiLoaded = (map: any, maps: any) => {
        const boundsRestriction = new maps.LatLngBounds(
          new maps.LatLng(italyBounds.south, italyBounds.west),
          new maps.LatLng(italyBounds.north, italyBounds.east)
        );
    
        // Imposta i limiti per non trascinare fuori dall'Italia
        map.setOptions({
          restriction: {
            latLngBounds: boundsRestriction,
            strictBounds: true,
          },
        });

        // Prendo le coordinate di tutte le farmacie
        let coordinates: MapProps[] = listaFarmacie?.map(f => ({ lat: f.store.latitude, lng: f.store.longitude } as MapProps));

        // Recupero le coordinate delle farmacie più vicine
        let coordNearly: MapProps | null= GetNearlyLocation(centerMap, coordinates);

        let bounds = new maps.LatLngBounds();
        bounds.extend(centerMap)
        bounds.extend({lat: coordNearly!.lat, lng: coordNearly!.lng} as MapProps)

        map.fitBounds(bounds);

        map.setCenter(centerMap)
        setZoom(map.getZoom() - 1)
      };

  function visualizzaFormAccount(): void {
    if (pharmaSelected?.store?.name) {
      setShowForm(true);
        window.scrollTo({
          top: 0
        });
    } else {
      setShowErrorPharmacy(true);
    }
  }

  function showSelectFarmacia() {

    setAddress('');
    setFilteredPharma([]);

    if(pharmaSelected) {
      setCenterMap({ lat: pharmaSelected?.store.latitude, lng: pharmaSelected?.store.longitude })
    }

    setShowForm(false);
    window.scrollTo({
      top: 0
    });
  }

  function errorPosition(positionError: GeolocationPositionError): void {
    if(positionError.code === GeolocationPositionError.PERMISSION_DENIED) {
      setShowAlertGeoLocalization(true)
    }
    impostaCoordinateAssenzaValori();
    setStateGettingCoordinated(true);
    setGeoLocationActive(false);
  }

  useEffect(() => {

    navigator.geolocation.getCurrentPosition(setPosition, errorPosition, {enableHighAccuracy: true});

    if(!listaFarmacie?.length) {

      setLoadingPharmacy(true);
      setTimeout(() => {

        if(isOnline){
          localStorage.removeItem('GET_PHARMA_LIST_TIME');
          localStorage.removeItem('pharmaList');
        }

        getPharmaList().then(async (data) => {
    
          let farmacie: Pharmacy_ItemList[] = [];
    
          if (data?.length > 0) {
            let temp_data = (data as pharmaModel[]).filter((g) => g.settings.app);
            temp_data?.forEach((g) => {
              let farmacieSingoloGruppo: Pharmacy_ItemList[] = g.stores.map((f) => {

                let pharmacy: Pharmacy_ItemList = {
                  groupId: g.groupId,
                  groupName: g.groupName,
                  store: f,
                }

                if(navigationCoords.lat && navigationCoords.lng) {
                  pharmacy.distanceFromPosition = CalculateGeoDistance(navigationCoords.lat,navigationCoords.lng,f.latitude, f.longitude);
                }
                return pharmacy;
      
              });

              farmacie = farmacie.concat(farmacieSingoloGruppo);
              listaFarmacieTemp = farmacie;

            });

            setListaFarmacie(farmacie);
            
          } // Fine IF farmacie trovate

          setLoadingPharmacy(false);
        })
      },100)
    }
    else {
      setLoadingPharmacy(false); 
    }

  },[isOnline]);  // Indico di reindirizzare il componente quando la variabile isOnline cambia valore


  const searchPharmacies = (value: string) => {

    let tempPharmacies: Pharmacy_ItemList[] | null = [];
    if(value) {
       tempPharmacies = listaFarmacie?.filter((x) => {
        if (
          x.store?.name?.toLowerCase().includes(value.toLowerCase()) ||
          x.groupName.toLowerCase().includes(value.toLowerCase()) ||
          x.store?.address?.address?.toLowerCase()?.includes(value.toLowerCase()) ||
          x.store?.address?.city
            ?.toString()
            ?.toLowerCase()
            ?.includes(value.toLowerCase()) ||
          x.store?.address?.zipCode
            ?.toString()
            ?.toLowerCase()
            ?.includes(value.toLowerCase())
        ) {
          return x;
        }
      });
    }

    setFilteredPharma(tempPharmacies);

    return tempPharmacies;
  };
  
  // controlla se sono state calcolate le distanze tra il punto della posizione (presa dalla geolocalizzazione)
  // e le farmacie
  const isCalculateDistances = (): boolean => {
    return (
      listaFarmacieTemp?.filter(f => f.distanceFromPosition)?.length > 0
    )
  }

  const firstStep = () => {

    const isMarkerPharmacySelected = (latMarker: number,lngMarker: number): boolean => {
      if(pharmaSelected?.store?.name) {
        return (
          pharmaSelected.store.latitude === latMarker &&
          pharmaSelected.store.longitude === lngMarker
        )
      }
      else {
        return false;
      }
    }

    // Ritorna un valore di z-index per i marker
    // più alto per il marker selezionato, dopo viene assegnato un valore con i marker associati alla ricerca
    // ed infine agli altri
    const get_ZIndex_Marker = (isSelected: boolean,isInMatchingAutoComplete: boolean): number => {
      let z_index_value: number = 1;

      if(isSelected){
        z_index_value = 3;
      }
      else if(isInMatchingAutoComplete) {
        z_index_value = 2;
      }

      return z_index_value;
    }

    const handleMarkerClick = (latitudeMarker: number,longitudeMarker: number) => {

      let buttonFullScreen: HTMLButtonElement = document.querySelector('.gm-fullscreen-control') as HTMLButtonElement;
      let refresh: boolean = false;

      // Se è attivo il fullscreen, renderizzo di nuovo la mappa in modo che una volta scelta una farmacia
      // viene rimosso in automatico il fullscreen
      if(buttonFullScreen && (buttonFullScreen.getAttribute('aria-pressed')?.toString() ===  'true')) {
        refresh = true;
        setStateGettingCoordinated(false);
      }


      let pharmacy: Pharmacy_ItemList | undefined = listaFarmacie
        .find(x=> x.store.latitude === latitudeMarker && x.store.longitude === longitudeMarker);

      if(pharmacy) {

     
         setPharmaSelected(pharmacy);

         let latitude: number = pharmacy.store.latitude;
         let longitude: number = pharmacy.store.longitude;

         setCenterMap({lat: latitude, lng: longitude})

         if(refresh) {
           setTimeout(() => {
            setStateGettingCoordinated(true); // Renderizzo di nuovo la mappa
           })
         }
        
      }
    }

    const MarkerPharma = (text: text) => {

      let width: number = 1.8;
      let height: number = 1.8;

      let markerFiltered: Pharmacy_ItemList | undefined = undefined

      if(filteredPharma?.length > 0) {
        markerFiltered = filteredPharma?.find(
          f => f?.store?.latitude === text.lat && f?.store?.longitude === text.lng
        )

        if(markerFiltered) {
          width = 1.8;
          height = 1.8;
        }
        else {
          width = 1.8;
          height = 1.8;
        }
      }

      if(pharmaSelected?.store?.name) {
        // Se è il marker associato alla farmacia selezionata
        if(pharmaSelected.store.latitude === text.lat && pharmaSelected.store.longitude === text.lng) {
          width = 1.4;
          height = 2.1;
        }
      }

    //  let dimensionImage: string = dimension+'rem';
      let translateX = (-width)/2 + 'rem';
      let translateY = (-height)+'rem';
      let dimensionWidth = width+'rem';
      let dimensionHeight = height+'rem';

      return (
        <div className="relative" 
          style={{ top: translateY,left: translateX, zIndex: get_ZIndex_Marker(isMarkerPharmacySelected(text.lat, text.lng), !!markerFiltered) }}>

          <img
            draggable={false}
            style={{ width: dimensionWidth, height: dimensionHeight }}
            src={
              isMarkerPharmacySelected(text.lat, text.lng)
              ?
              "https://maps.gstatic.com/mapfiles/api-3/images/spotlight-poi3_hdpi.png"
                : 
                (
                  markerFiltered
                  ?
                  "https://mt.google.com/vt/icon/name=icons/onion/SHARED-mymaps-pin-container-bg_4x.png,icons/onion/SHARED-mymaps-pin-container_4x.png,icons/onion/1899-blank-shape_pin_4x.png&highlight=ff000000,9c27b0,ff000000&scale=2.0"
                  :
                  "https://mt.google.com/vt/icon/name=icons/onion/SHARED-mymaps-pin-container-bg_4x.png,icons/onion/SHARED-mymaps-pin-container_4x.png,icons/onion/1899-blank-shape_pin_4x.png&highlight=ff000000,3949ab,ff000000&scale=2.0"
                )
            }
            alt=""
            onClick={() => confirmMarker(text.lat, text.lng)}
          />
        </div>
      );
    };

    const confirmMarker = (lat: number, lng: number) => {
      let pharmacy: Pharmacy_ItemList | undefined= listaFarmacie?.find(
        f => f.store.latitude === lat && f.store.longitude === lng
      )

      if (pharmaSelected?.store?.name !== pharmacy?.store?.name) {

        confirmDialog({
          message: () => (
            <>

            <div className="mt-2">
              <div>
                <strong style={{ fontSize: '1.2rem' }}> {pharmacy?.store?.name} </strong>
              </div>
              <small className="ml-2">
                {" "}
                {pharmacy?.store?.address.address +
                  " " +
                  pharmacy?.store?.address.city}{" "}
              </small>

            </div>
            </>
          ),
          header: 'Vuoi selezionare la farmacia?',
          acceptLabel: "Si",
          modal: true,
          accept: () => handleMarkerClick(lat, lng),
        });

      }
  }

    const MarkerPositionUser = (text: text) => (
      <div className="relative">
        <div className="marker-position-user">
          <div className="marker-position-user-bounce1"></div>
          <div className="marker-position-user-bounce2"></div>
        </div>
      </div>
    );

    const CustomPosition = (props: customButtonProps) => {
      return(
        <div className=" flex align-items-center ">
          <Button id="researchButton" className="button-icon-signup-compass" icon="bi bi-crosshair"  aria-label="Filter" 
            onClick={() => {onMyPosition()}} > 
          </Button>
    
        </div>
      )
    }

    const onResearchAddress = (researchAddress?: string) => {
      let addressSearch: string = researchAddress ? researchAddress : address;
      if (addressSearch) {
        fromAddress(addressSearch)
          .then(({ results }) => {
            const { lat, lng } = results[0].geometry.location;

            if (results[0].types.includes("pharmacy")) {
              researchFromPharmacyList();
            } else {

              setCenterMap({lat: lat, lng: lng})

              let positionUser: MapProps = {
                lat: lat,
                lng: lng,
              };

              setUserCoordinates(positionUser);

              // setZoom(18);
              let coordinates: MapProps[] = listaFarmacie?.map(f => ({ lat: f.store.latitude, lng: f.store.longitude } as MapProps))
              let coordNearly: MapProps | null= GetNearlyLocation(results[0].geometry.location, coordinates);
      
              let pharmacyNearly: Pharmacy_ItemList | undefined= listaFarmacie
                ?.find(f => f.store.latitude === coordNearly?.lat && f.store.longitude === coordNearly.lng);
    
    
           
                let bounds = new mapRef.maps.LatLngBounds();
                bounds.extend({lat: lat, lng: lng} as MapProps)
                bounds.extend({lat: pharmacyNearly?.store.latitude, lng: pharmacyNearly?.store.longitude} as MapProps)
    
                mapRef.map.fitBounds(bounds);
                setZoom(mapRef.map.getZoom() - 1);
                setFilteredPharma([]);
          
            }
          })
          .catch(() => {
            researchFromPharmacyList();
          });

      } 
      // Se l' indirizzo è vuoto 
      else {

        setFilteredPharma([]);
        setCenterMap({lat: userCoordinates.lat, lng: userCoordinates.lng});
        
        setZoom(17)
        //showWarning("Digita il nome di una farmacia o un indirizzo.");
      }
    };

    const researchFromPharmacyList = (addressValue?: string) => {
     
            // Se l' indirizzo non è valido ma ci sono farmacie
            let pharmacyMatch = addressValue ? searchPharmacies(addressValue) : searchPharmacies(address);

            if (pharmacyMatch?.length > 0) {
              
              let latPharmacy: number = pharmacyMatch[0].store.latitude;
              let lngPharmacy: number = pharmacyMatch[0].store.longitude;

              setCenterMap({ lat: latPharmacy, lng: lngPharmacy })

              if (pharmacyMatch.length === 1) {
                setZoom(17);
              } else {
                setZoom(10);
              }

              if(navigationCoords.lat && navigationCoords.lng) {
                setUserCoordinates(navigationCoords)
              }
            }
            // altrimenti se l' input digitato non ha corrispondenza neanche con le farmacie
            // visualizzo un avviso
            else {
              setFilteredPharma(listaFarmacie);
              showError("Nessun risultato disponibile.");
            }
            
    } 
    const showWarning = (message: string) => {
      toast.current?.show({ severity: 'warn', summary: 'Avviso', detail: message });
    }

    const showError = (message: string) => {
      toast.current?.show({ severity: 'error', summary: 'Errore', detail: message });
    }

    // Funzione utilizzata per indicare quando è necessario utilizzare l' allineamento centralizzato
    const applyCenterContent = () => {
      return (
        !isOnline && listaFarmacie.length > 0
      )
    }

    const onMyPosition = () => {

      //setFilteredPharma([]);

      //setStateGettingCoordinated(false)
      navigator.geolocation.getCurrentPosition(
        (pos) => {
          centerOnMyPosition(pos.coords.latitude,pos.coords.longitude);
        },
        () => {},
        { enableHighAccuracy: true}
      )
    }

    return (
      <>
        <div className="header-login">
          <div className="grid mt-1 title-scegli-farmacia">
            <div className="col-2 flex align-items-center justify-content-start pl-4">

              <div className="flex flex-column" style={{cursor:'pointer'}} onClick={() => goTo("/login")}>
                <div className="flex align-items-center justify-content-center text-white">
                  <i className="pi pi-arrow-left icons-header"></i>         
                </div>
                <div className="flex align-items-center justify-content-center font-bold text-white" 
                  style={{  position: 'relative', top: '-5px' }} >
                    <label style={{ fontSize: '8px', fontWeight: 'bold' }} htmlFor="backLoginButton">INDIETRO</label>
                </div>
              </div>

            </div>

            <div className="col-8 flex flex-column align-items-center justify-content-center">

              {
                  process.env.REACT_APP_SUFFIX_TITLE_HEADER
                  ? 
                  <div className="flex flex-column mt-1">
                    <div>Scegli una farmacia</div>

                    <div className="flex justify-content-end text-sm font-normal">
                      <div className="flex align-items-center justify-content-center title-login">
                          {process.env.REACT_APP_SUFFIX_TITLE_HEADER}
                      </div>
                    </div>
                  </div>
                  :
                  <span className="mb-2">Scegli una farmacia</span>
              }
              
            </div>
          </div>
        </div>

        <div className={ 'content-login signup-class relative ' + (applyCenterContent() ? 'align-content-center' : '') }>
          {
            (listaFarmacie?.length > 0)
            ?
            <>

            {
              isOnline && isGettingCoordinates
              ?
              <div style={{ position: 'relative', width: '100%', height: '50vh' }}>

              <div className="h-full">
                <GoogleMapReact
                
                  yesIWantToUseGoogleMapApiInternals={true}
                  onGoogleApiLoaded={(map) => {setMapRef(map); handleApiLoaded(map.map,map.maps)}}
                  bootstrapURLKeys={{ 
                    key: googleMapsApiKey,
                    language: 'it',
                    region: 'it',
                    libraries:['places','visualization'],
                  }}
                  center={centerMap}
                  zoom={zoom}
                  options={{
                    fullscreenControlOptions: {
                      position: 12
                    }
                  }}
                  >

                    {
                      listaFarmacie.map((item:Pharmacy_ItemList,index: number) => 
                        <MarkerPharma
                          key={index}
                          lat={item.store.latitude}
                          lng={item.store.longitude}
                          text={item.store.name}
                        />
                      )  
                    }

                    <MarkerPositionUser 
                      lat={userCoordinates.lat}
                      lng={userCoordinates.lng}
                      text={'TU'}
                    />


                </GoogleMapReact>
                {
                  geoLocationActive
                  ?
                    <CustomPosition position={4} />
                  :
                  <></>
                }
                </div>
                        
                {/* 
                  Agganciando il messaggio di conferma al div con aria-label="Mappa" posso far uscire il popup di conferma anche quando
                  la mappa è a schermo intero. Senza questa modifica il popup usciva solo quando ci si toglieva dallo schermo intero
                */}
                     
                <ConfirmDialog className="signup-choose-pharamacy-dialog" 
                  appendTo={() => document.querySelectorAll('[aria-label="Mappa"]')[0] as HTMLElement }/>
                     
              </div> 
              :
              <></>
            }

              <div className="flex flex-column gap-5 ">
            <div className="w-full flex flex-column align-items-center justify-content-center">
              <div className="flex flex-wrap justify-content-center align-items-center gap-5 w-full mt-5">

                <div className="flex flex-row w-full">

                  <div className="flex flex-row w-full">

                    <div className="flex-grow-1 flex align-items-center justify-content-center ml-4 mr-4 relative">

                      <AutocompletePharmacy pharmacies={listaFarmacie} geoLocationActive={geoLocationActive} 
                        address={address} panelClassAutocomplete="panel-class-autocomplete-pharmacy"
                        onChangeSelection={(e: autocompletePharmacyOutputModel) => {
                          if(e.typeSuggestion === Enum_TypeSuggestion.Pharmacy) {
                            let pharmacy: Pharmacy_ItemList | undefined = listaFarmacie
                              .find(f => f.store.latitude === e.coord.lat && f.store.longitude === e.coord.lng);

                              if(pharmacy) {
                                researchFromPharmacyList(pharmacy.store.name);
                                setPharmaSelected(pharmacy);
                              }
                          }
                          else {
                            onResearchAddress(e.label)
                          }
                        }}
                      />
                    </div>

                  </div>
                  
                </div>
                
                </div>

                {/* <div className="flex align-items-center align-content-start justify-content-start w-full px-4" >
                    <span className="info-description">
                      Inserisci il nome di una farmacia o un indirizzo.
                    </span>
                  </div> */}

                {
                  pharmaSelected?.store?.name 
                  ?

                  <div className="flex flex-row w-full w-full px-4 mt-5">
                    <div className="w-full">
                      <SignupInfoPharmacy pharmacy={pharmaSelected.store} />
                    </div>
                  </div>
                  :

                  <></>
                }
          

                <div className="flex flex-column w-full">

              
               

                <Button onClick={() => visualizzaFormAccount()}
                  disabled={!pharmaSelected?.store?.storeCode}
                  label="Continua"
                  style={{ borderRadius: "24px" }}
                  className="w-20rem mx-auto mt-5">
                  
                    <i className="pi pi-arrow-right" style={{ marginLeft: "-12px" }}></i>
                </Button>

                </div>

                </div>
          
                <div>
              </div>
            </div>

              </>
              :
              isGettingCoordinates && (!listaFarmacie?.length) && (!loadingPharmacy)
              ?
              <div style={{ marginTop: '3rem' }} >
                <div className="flex justify-content-center">
                  <h2 className="mb-0 mt-2">Registrazione</h2>
                </div>

                <div className="text-center px-3 mt-5">
                  Nessuna Farmacia trovata per eseguire la registrazione.
                </div>
              </div>
              :
              <></>
              }

        <Toast ref={toast} position="top-center"/>


        {
          showAlertGeoLocalization
          ?
          <PopupGeolocationComponent onClose={() => setShowAlertGeoLocalization(false) } />
          :
          <></>
        }

        </div>

        <FooterPreLoginComponent />
      </>
    );
  };

  return (
    <>
      <PopupInstallComponent openManually={true} showBehaviorManually={showPopupInstall} 
        onClosePopup={() => {
          if(showPopupInstall) {
              setShowPopupInstall(false)
          }}
        }
      />
      {!showForm ? (
        firstStep()
      ) : (
        <div className="signup-class">
          
          <div>
            
            {/* <div className="flex align-items-center justify-content-center"></div> */}
            <div className="header-login">

            <div className="grid mt-1 title-scegli-farmacia">
              <div className="col-2 flex align-items-center justify-content-start pl-4">

                <div className="flex flex-column" style={{cursor:'pointer'}} onClick={() => showSelectFarmacia()}>
                  <div className="flex align-items-center justify-content-center text-white">
                    <i className="pi pi-arrow-left icons-header"></i>         
                  </div>
                  <div className="flex align-items-center justify-content-center font-bold text-white" 
                    style={{  position: 'relative', top: '-5px' }} >
                      <label style={{ fontSize: '8px', fontWeight: 'bold' }} htmlFor="backPharmaciesButton">INDIETRO</label>
                  </div>
                </div>
                
              </div>

              <div className="col-8 flex align-items-center justify-content-center">

                {
                  process.env.REACT_APP_SUFFIX_TITLE_HEADER
                  ? 
                  <div className="flex flex-column mt-1">
                    <div>Registrati</div>

                    <div className="flex justify-content-end text-sm font-normal">
                      <div className="flex align-items-center justify-content-center title-login">
                          {process.env.REACT_APP_SUFFIX_TITLE_HEADER}
                      </div>
                    </div>
                  </div>
                  :
                  <span className="mb-2">Registrati</span>
                }
              </div>
            </div>

            </div>
          </div>

          <div className="content-login ">
            {" "}
            {/*login-background*/}
            <div className="flex flex-column  gap-5 content-scroll ">{/*md:flex-row*/}
              <div className="w-full flex flex-column align-items-center justify-content-center gap-5 ">{/*md:w-5*/}
                <div className="w-full flex flex-column align-items-center justify-content-center pos-rel mt-4 ">{/*md:w-5*/}

                  { /* Sezione farmacia selezionata */ }

                  <div className="w-full flex align-items-center justify-content-center ">
                    <hr className="hr-style " />
                    <div className="box-title ">
                      <i className="pi pi-building mx-1"></i>Farmacia
                    </div>
                  </div>

                  <div className="flex justify-content-center gap-3 mb-4 mt-7 w-full">
                    <div className="col-12 flex flex-column align-items-center justify-content-center mt-3">

                      <div className="text-lg font-bold mb-2 text-center">{pharmaSelected?.store?.name}</div>

                      <div className="mb-3 mt-1 text-center text-700">
                        <i className="pi pi-map-marker mr-1 " style={{ color: 'var(--primary-color)' }}></i>
                        <span className=" text-base signup-text-color">
                          {pharmaSelected?.store?.address?.address+' '+pharmaSelected?.store?.address?.city}
                        </span>
                      </div>

                    </div>
                  </div>

                  { /* Fine sezione farmacia selezionata */ }
                  <div className="w-full flex align-items-center justify-content-center mb-2 ">
                    <hr className="hr-style " />
                    <div className="box-title ">
                      <i className="pi pi-id-card mx-1"></i>Anagrafica
                    </div>
                  </div>
                  <div className="flex flex-column mb-4 mt-4 signup-input-style">
                    <span className="p-float-label label-signup ">
                      <InputText
                        className="w-full"
                        value={name.value}
                        tabIndex={1}
                        onChange={(e) => {
                          onChangeName(e.target.value);
                        }}
                        invalid={!name.valid && name.showError}
                        onBlur={()=> onBlurName()}
                        maxLength={MAXLENGTH_NAME}
                      />
                      <label htmlFor="Nome" className="signup-text-color">Nome*</label>
                    </span>

                    {name.valid || !name.showError ? (
                      ""
                    ) : (
                      <span>
                        <small className="text-red-600">
                          Campo obbligatorio
                        </small>
                      </span>
                    )}
                  </div>

                  <div className="flex flex-column mb-4 mt-3 signup-input-style">
                    <span className="p-float-label label-signup">
                      <InputText
                        className="w-full"
                        value={surname.value}
                        tabIndex={2}
                        onChange={(e) => {
                          onChangeSurname(e.target.value);
                        }}
                        invalid={!surname.valid && surname.showError}
                        onBlur={() => onBlurSurname()}
                        maxLength={MAXLENGTH_SURNAME}
                      />
                      <label htmlFor="Cognome" className="signup-text-color">Cognome*</label>
                    </span>

                    {surname.valid || !surname.showError ? (
                      ""
                    ) : (
                      <span>
                        <small className="text-red-600">
                          Campo obbligatorio
                        </small>
                      </span>
                    )}

                    {
                      (!checkCharsNameSurname)
                      ?
                      <span>
                        <small className="text-red-600">
                          La somma di caratteri del nome e del cognome non deve superare i 99 caratteri
                        </small>
                      </span>
                      :
                      <></>
                    }
                  </div>

                  <div className="flex flex-column mt-3 signup-input-style">
                    <span className="p-float-label label-signup">
                      <InputText 
                        className="w-full"
                        value={nationalIdNumber.value}
                        tabIndex={3}
                        onChange={(e) => {
                          onChangeNationalIdNumber(e.target.value);
                        }}
                        invalid={
                          !nationalIdNumber.valid && nationalIdNumber.showError
                        }
                        onBlur={() => {
                          onBlurNationalIdNumber();
                        }}
                        maxLength={MAXLENGTH_NATIONAL_ID_NUMBER}
                      />
                      <label htmlFor="CodiceFiscale" className="signup-text-color">Codice Fiscale*</label>
                    </span>

                    {!nationalIdNumber.showError || nationalIdNumber.valid ? (
                      ""
                    ) : (
                      <span>
                        <small className="text-red-600">
                          {" "}
                          {getErrorCodiceFiscale()}{" "}
                        </small>
                      </span>
                    )}
                  </div>
                </div>

                <div className="w-full flex flex-column align-items-center justify-content-center gap-5 pos-rel ">{/*md:w-5*/}
                  <div className="w-full flex align-items-center justify-content-center mt-5 ">
                    <hr className="hr-style " />
                    <div className="box-title ">
                      <i className="pi pi-address-book mx-1"></i>Recapiti
                    </div>
                  </div>

                  <div className="flex flex-column signup-input-style">
                    <span className="p-float-label label-signup">
                      <InputText
                        type="tel"
                        className="w-full"
                        value={phone.value}
                        tabIndex={4}
                        keyfilter="pnum"
                        maxLength={MAXLENGTH_PHONE}
                        onChange={(e) => {
                          onChangePhone(e.target?.value ? e.target.value : null);
                        }}
                        invalid={!phone.valid && phone.showError}
                        onBlur={() => {
                          onBlurPhone();
                        }}
                      />
                      <label htmlFor="Telefono" className="signup-text-color">Cellulare*</label>
                    </span>
                    {phone.valid || !phone.showError ? (
                      ""
                    ) : (
                      <span>
                        <small className="text-red-600">
                          {" "}
                          Formato non valido{" "}
                        </small>
                      </span>
                    )}
                  </div>

                  <div className="flex flex-column signup-input-style mt-3">
                    <span className="p-float-label label-signup">
                      <InputText 
                        type="email"
                        className="w-full"
                        value={email.value}
                        tabIndex={5}
                        onChange={(e) => {
                          onChangeEmail(e.target.value);
                        }}
                        invalid={!email.valid && email.showError}
                        onBlur={() => {
                          onBlurEmail();
                        }}
                        keyfilter="email"
                        maxLength={MAXLENGTH_EMAIL}
                      />
                      <label htmlFor="Email" className="signup-text-color">Email*</label>
                    </span>

                    {email.valid || !email.showError ? (
                      ""
                    ) : (
                      <span>
                        <small className="text-red-600">
                          {" "}
                          {getErrorEmail()}{" "}
                        </small>
                      </span>
                    )}
                  </div>
                  <div className="flex flex-column signup-input-style mt-3">
                    <span className="p-float-label label-signup">
                      <InputText
                        type="email"
                        className="w-full"
                        value={matchEmail.value}
                        tabIndex={6}
                        onChange={(e) => {
                          onChangeMatchEmail(e.target.value);
                        }}
                        invalid={!matchEmail.valid && matchEmail.showError}
                        onBlur={() => {
                          onBlurMatchEmail();
                        }}
                        keyfilter="email"
                        maxLength={MAXLENGTH_EMAIL}
                      />
                      <label htmlFor="ConfermaEmail" className="signup-text-color">Conferma Email*</label>
                    </span>

                    {matchEmail.valid || !matchEmail.showError ? (
                      ""
                    ) : (
                      <span>
                        <small className="text-red-600">
                          {" "}
                          {getErrorMatchEmail()}{" "}
                        </small>
                      </span>
                    )}
                  </div>
                </div>

                <div className="w-full flex flex-column align-items-center justify-content-center gap-5 pos-rel ">{/*md:w-5*/}
                  <div className="w-full flex flex-wrap justify-content-center align-items-center  ">
                    <div className="w-full flex align-items-center justify-content-center mt-5 mb-5 ">
                      <hr className="hr-style " />
                      <div className="box-title ">
                        <i className="pi pi-user mx-1  "></i>
                        Account
                      </div>
                    </div>

                    <div className="flex flex-column signup-input-style">
                      <span className="p-float-label label-signup">
                        <InputText
                          className="w-full"
                          value={username.value}
                          tabIndex={7}
                          autoComplete="off"
                          name="one-time-code-username"
                          id="username"
                          style={{ width: "100%" }}
                          onChange={(e) => onChangeUsername(e.target.value)}
                          onBlur={() => onBlurUsername()}
                          invalid={!username.valid && username.showError}
                          maxLength={MAXLENGTH_USERNAME}
                        />
                        <label htmlFor="Username" className="signup-text-color">Username*</label>
                      </span>
                      {username.valid || !username.showError ? (
                        ""
                      ) : (
                        <div className="flex flex-column w-full">
                          <small>
                            {
                              username.value.length === 0 ?
                                <span className="text-red-600">Campo obbligatorio.</span>
                              :
                              <span className="text-red-600">L' username non deve essere una email</span>
                            }
                          </small>
                        </div>
                      )}
                    </div>
                    

                  </div>

                  <div className="flex flex-column justify-content-center align-items-center signup-input-style mt-3 ">
                    <span className="p-float-label w-full">
                      <Password
                        className="input-psw-width w-full "
                        value={password.value}
                        inputRef={ref => ref?.setAttribute('tabIndex','7')}
                        onChange={(e) => onChangePassword(e.target.value)}
                        autoComplete="off"
                        name="one-time-code-password"
                        feedback={false}
                        onBlur={() => onBlurPassword()}
                        toggleMask
                        maxLength={MAXLENGTH_PASSWORD}
                        invalid={ !password.valid && password.showError }
                      />
                      <label
                        htmlFor="Password"
                        className={  "signup-text-color" +
                          password.valid || !password.showError
                            ? "signup-text-color"
                            : "text-red-600 "
                        }
                      >
                        Password*
                      </label>
                    </span>
                    {
                      password.valid || !password.showError ? (
                        <></>
                      ) : (
                        <div className="flex flex-column w-full">
                          <small>
                            {
                              password.value.length === 0 ?
                                <span className="text-red-600 ">Campo Obbligatorio.</span>
                              :
                               <span className="text-red-600">Deve contenere minimo 8 caratteri, di cui almeno uno in maiuscolo e un numero</span> 
                            }
                          </small>
                        </div>
                      )
                    }
                  </div>

                  <div className="flex flex-column justify-content-center align-items-center signup-input-style mt-3 mb-3 ">
                    <span className="p-float-label w-full">
                      <Password
                        className="w-full"
                        name="one-time-code-conf-password"
                        value={matchPassword.value}
                        inputRef={ref => ref?.setAttribute('tabIndex','8')}
                        onChange={(e) => onChangeMatchPassword(e.target.value)}
                        feedback={false}
                        onBlur={() => onBlurMatchPassword()}
                        toggleMask
                        maxLength={MAXLENGTH_PASSWORD}
                        invalid={ !password.valid && password.showError }
                      />
                      <label
                        htmlFor="ConfermaPassword"
                        className={ "signup-text-color" +
                          matchPassword.valid || !matchPassword.showError
                            ? "signup-text-color"
                            : "text-red-600" 
                        }
                      >
                        Conferma Password*
                      </label>
                    </span>
                    {matchPassword.valid || !matchPassword.showError ? (
                      ""
                    ) : (
                      <div className="flex flex-column w-12">
                        <small className="text-red-600">
                          <span>{getErrorMatchPassword()}</span>
                        </small>
                      </div>
                    )}
                  </div>
                </div>

                <Button
                  onClick={() => {
                    onSignup();
                    // setVisible(true)
                  }}
                  label="Registrati"
                  // disabled={!isFormValid()}
                  style={{ borderRadius: "24px" }}
                  className="w-20rem mx-auto mb-2"
                ></Button>

                <Dialog
                  visible={popupSuccessVisible}
                  modal={true}
                  // header={headerElement}
                  footer={footerContent}
                  style={{ width: "22rem" }}
                  closable={false}
                  onHide={() => setPopupSuccessVisible(false)}
                >
                  <p className="m-0">Registrazione avvenuta con successo</p>
                </Dialog>
              </div>
              
              <FooterPreLoginComponent />
            </div>
            
          </div>

        </div>
        
      )}
      
    </>
  );
}
